import { Component, OnInit, inject } from '@angular/core';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { Router } from '@angular/router';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  imports: [
    MatCardModule,
    MatButtonModule,
  ],
})
export class LandingComponent implements OnInit {
  private identityService = inject(IdentityService);
  private router = inject(Router);

  
 


  

  ngOnInit() {
    if (this.identityService.isLoggedIn()) {
      this.router.navigate([AppUrls.home()]);
    }
  }

  signIn() {
    this.identityService.redirectToThirdPartyLogin();
  }
}
